interface BookingMachine {
  id: number;
  name: string;
}

interface BookingProject {
  id: number;
  name: string;
}

export interface Booking {
  driverId: number;
  driverName: string;
  endDate: string;
  id: number;
  isPrivateUse: boolean;
  machine: BookingMachine;
  project?: BookingProject;
  startDate: string;
  intention: string;
  driverHasDriverLicense: boolean;
}

export interface CreateBooking {
  id?: number;
  startDate?: string;
  startTime?: string;
  endDate?: string;
  endTime?: string;
  machine?: {
    id: number;
    name: string;
  };
  projectId?: number;
  canBePrivate?: boolean;
  isPrivateUse?: boolean;
  intention?: string;
  driverHasDriverLicense?: boolean;
}

export interface UserInfo {
  companyId: number;
}

type CompanyModuleSetting = {
  [setting: string]: {
    description: string;
    value: boolean;
    onlyForGlobalAdmin: boolean;
  }[];
};

export const VEHICLE_BOOKING_COMPANY_SETTING = 'VehicleBooking';
export const DRIVING_LICENCE_BOOKING_OPTION = 'Show driver license check';

export type Company = {
  type: string;
  info: string;
  parentCompany: {
    id: number;
    name: string;
  };
  subCompaniesCount: number;
  machinesCount: number;
  usersCount: number;
  organizationNumber: string;
  id: number;
  name: string;
  moduleSettings?: CompanyModuleSetting;
};

export interface Project {
  projectId: number;
  projectType: number;
  name: string;
  ownerCompanyId: number;
  description: string;
  comment: string;
  active?: boolean;
  startUtcTime?: string;
  endUtcTime?: string;
}

// export interface Project {
//   id: number;
//   name: string;
// }

export class PostBooking {
  startDate?: string;
  endDate?: string;
  machineId?: number;
  projectId?: number;
  isPrivateUse?: boolean;
  intention?: string;
  driverHasDriverLicense?: boolean;

  constructor(booking: Booking) {
    this.startDate = booking.startDate;
    this.endDate = booking.endDate;
    this.machineId = booking.machine.id;
    this.projectId = booking.project?.id;
    this.isPrivateUse = booking.isPrivateUse;
    this.intention = booking.intention;
    this.driverHasDriverLicense = booking.driverHasDriverLicense;
  }
}

export interface Machine {
  id: number;
  isPrivateBookingEnabled: boolean;
  isEnabledCheckingFunctionality: boolean;
  name: string;
}

export enum BookingType {
  BUSINESS = 0,
  PRIVATE = 1,
}
